<template>
	<nav class="header-nav">
		
		<router-link
			to="/summary"
			class="btn btn--blue4 header-nav__link"
			active-class="active"
			>Summary</router-link
		>
		<router-link
			to="/listOrders"
			class="btn btn--blue4 header-nav__link"
			active-class="active"
			>List Orders</router-link
		>
		<router-link
			v-if="(this.userInfo.usergrp == 'Admin' || this.userInfo.usergrp == 'Printing') "
			to="/download"
			class="btn btn--blue4 header-nav__link"
			active-class="active"
			>Download</router-link
		>
		<router-link
			v-if="(this.userInfo.usergrp == 'Admin' || this.userInfo.usergrp == 'Scan') "
			to="/workStation"
			class="btn btn--blue4 header-nav__link"
			active-class="active"
			>WorkStation</router-link
		>
		<router-link
			v-if="(this.userInfo.usergrp == 'Admin' || this.userInfo.usergrp == 'Delivery') "
			to="/delivery"
			class="btn btn--blue4 header-nav__link"
			active-class="active"
			>Delivery</router-link
		>
		<!--
		<router-link
			to="/info"
			class="btn btn--blue4 header-nav__link"
			active-class="active"
			>Info</router-link
		>-->
		<router-link
			to="/reports"
			class="btn btn--blue4 header-nav__link"
			active-class="active"
			>Reports</router-link
		>
		<router-link
			v-if="(this.userInfo == 'Admin' ) "
			to="/users"
			class="btn btn--blue4 header-nav__link"
			active-class="active"
			>Users</router-link
		>
		
	</nav>
	
	
	
</template>

<script>
import Vue from "vue";
export default Vue.extend({
	name: "HeaderNav",
	components: {},
	props: {
		userInfo: {}
	},
});
</script>

<style lang="scss" scoped>
.header-nav {
	align-self: center;
	&__link {
		text-transform: uppercase;
		letter-spacing: 1.05px;
		font-weight: 600;
		font-size: 12px;

		display: inline-block;
		padding: 10px 13px;
		margin: 0 2px;

		&.active {
			background-color: $color4L;
		}
	}

	&__link:first-child {
		border-top-left-radius: 5px;
	}

	&__link:last-child {
		border-top-right-radius: 7px;
	}
}
</style>